const vessels = [{
        cName: "Vessel, Florida Resident (U.S. Citizen only), Recreational or Commercial Use",
        oSubMenu: [
            // 1 TO 11  done
            {
                cName: "100 Vessel, 1 to 11 feet in length and all canoes with motor",
                cReturn: "100 Vessel, Florida Resident (U.S. Citizen only), Recreational or Commercial Use, 1 to 11 feet 11 inches in length & all canoes with motor|5.50|5.50|5.50|5.50|5.50|5.50|5.50|5.50|5.50|5.50|5.50|5.50|11.00|11.00|11.00|5|5.50|2|2|2|0"
            },
            //12 TO 15  done
            {
                cName: "100 Vessel 12 to 15 feet in length",
                cReturn: "100 Vessel, Florida Resident (U.S. Citizen only), Recreational or Commercial Use, 12 to 15 feet 11 inches in length |16.25|16.25|16.25|16.25|16.25|16.25|16.25|16.25|16.25|16.25|16.25|16.25|32.50|32.50|32.50|5|16.25|2|2|2|0"
            },
            // 16 TO 25  done
            {
                cName: "100 Vessel, 16 to 25 feet in length",
                cReturn: "100 Vessel, Florida Resident (U.S. Citizen only), Recreational or Commercial Use, 16 to 25 feet 11 inches in length|28.75|28.75|28.75|28.75|28.75|28.75|28.75|28.75|28.75|28.75|28.75|28.75|57.50|57.50|57.50|5|28.75|2|2|2|0"
            },
            // 26 TO 39  done
            {
                cName: "100 Vessel, 26 to 39 feet in length",
                cReturn: "Vessel, Florida Resident (U.S. Citizen only), Recreational or Commercial Use, 26 to 39 feet 11 inches in length|78.25|78.25|78.25|78.25|78.25|78.25|78.25|78.25|78.25|78.25|78.25|78.25|156.50|156.50|156.50|5|78.25|2|2|2|0"
            },
            // 40 TO 64  done
            {
                cName: "100 Vessel, 40 to 64 feet in length",
                cReturn: "100 Vessel, Florida Resident (U.S. Citizen only), Recreational or Commercial Use, 40 to 64 feet 11 inches in length|127.75|127.75|127.75|127.75|127.75|127.75|127.75|127.75|127.75|127.75|127.75|127.75|255.50|255.50|255.50|5|127.75|2|2|2|0"
            },
            //65 TO 109  done
            {
                cName: "100 Vessel, 65 to 109 feet in length",
                cReturn: "100 Vessel, Florida Resident (U.S. Citizen only), Recreational or Commercial Use, 65 to 109 feet 11 inches in length|152.75|152.75|152.75|152.75|152.75|152.75|152.75|152.75|152.75|152.75|152.75|152.75|305.50|305.50|305.50|5|152.75|2|2|2|0"
            },
            //OVER 110+  done
            {
                cName: "100 Vessel, 110+ feet in length",
                cReturn: "100 Vessel, Florida Resident (U.S. Citizen only), Recreational or Commercial Use, 110+ feet in length|189.75|189.75|189.75|189.75|189.75|189.75|189.75|189.75|189.75|189.75|189.75|189.75|379.50|379.50|379.50|5|189.75|2|2|2|0"
            },
            //DEALER  done
            {
                cName: "101 Vessel Dealer",
                cReturn: "101 Vessel, Florida Resident (U.S. Citizen only), Recreational or Commercial Use, Vessel Dealer|25.50|25.50|25.50|25.50|25.50|25.50|25.50|25.50|25.50|25.50|25.50|25.50|51.00|51.00|51.00|2|2|2|2|2|0"
            }, //EXEMPT
            {
                cName: "Exempt Vessel,Girl Scout,Boy Scout,Government",
                cReturn: "Vessel, Florida Resident (U.S. Citizen only), Recreational or Commercial Use, Exempt Vessel,Girl Scout,Boy Scout,Government|0.00|0.00|0.00|0.00|0.00|0.00|0.00|0.00|0.00|0.00|0.00|0.00|0.00|0.00|0.00|5|2|2|2|2|0"
            },
            //ANTIQUE
            {
                cName: "Antique Vessel, at least 30 years old, Recreational Use only, with certification",
                cReturn: "Antique Vessel, at least 30 years old, Florida Resident (U.S. Citizen only), Recreational Use only, with certification|0.00|0.00|0.00|0.00|0.00|0.00|0.00|0.00|0.00|0.00|0.00|0.00|0.00|0.00|0.00|5|0.00|2|2|2|0"
            },
        ]
    }, //non-Florida Resident or Non-US
    {
        cName: "Vessel, NON-Florida Resident or NON-U.S. Citizen, Recreational Use Only or Commercial Exempt",
        oSubMenu: [{
                cName: "100 Vessel, 1 to 11 feet in length and all canoes with motor",
                cReturn: "100 Vessel, NON-Florida Resident or NON-U.S. Citizen, Recreational Use Only or Commercial Exempt, 1 to 11 feet in length & all canoes with motor|5.50|5.50|5.50|5.50|5.50|5.50|5.50|5.50|5.50|5.50|5.50|5.50|11.00|11.00|11.00|5|5.50|2|2|2|0"
            }, //done
            {
                cName: "100 Vessel, 12 to 15 feet in length",
                cReturn: "100 Vessel, NON-Florida Resident or NON-U.S. Citizen, Recreational Use Only or Commercial Exempt, 12 to 15 feet in length|16.25|16.25|16.25|16.25|16.25|16.25|16.25|16.25|16.25|16.25|16.25|16.25|32.50|32.50|32.50|5|16.25|2|2|2|0"
            }, //done
            {
                cName: "100 Vessel, 16 to 25 feet in length",
                cReturn: "100 Vessel, NON-Florida Resident or NON-U.S. Citizen, Recreational Use Only or Commercial Exempt, 16 to 25 feet in length|28.75|28.75|28.75|28.75|28.75|28.75|28.75|28.75|28.75|28.75|28.75|28.75|57.50|57.50|57.50|5|28.75|2|2|2|0"
            }, //done
            {
                cName: "100 Vessel, 26 to 39 feet in length",
                cReturn: "100 Vessel, NON-Florida Resident or NON-U.S. Citizen, Recreational Use Only or Commercial Exempt, 26 to 39 feet in length|78.25|78.25|78.25|78.25|78.25|78.25|78.25|78.25|78.25|78.25|78.25|78.25|156.50|156.50|156.50|5|78.25|2|2|2|0"
            }, //done
            {
                cName: "100 Vessel, 40 to 64 feet in length",
                cReturn: "100 Vessel, NON-Florida Resident or NON-U.S. Citizen, Recreational Use Only or Commercial Exempt, 40 to 64 feet in length|127.75|127.75|127.75|127.75|127.75|127.75|127.75|127.75|127.75|127.75|127.75|127.75|255.50|255.50|255.50|5|127.75|2|2|2|0"
            }, //done
            {
                cName: "100 Vessel, 65 to 109 feet in length",
                cReturn: "100 Vessel, NON-Florida Resident or NON-U.S. Citizen, Recreational Use Only or Commercial Exempt, 65 to 109 feet in length|152.75|152.75|152.75|152.75|152.75|152.75|152.75|152.75|152.75|152.75|152.75|152.75|305.50|305.50|305.50|5|152.75|2|2|2|0"
            }, //done
            {
                cName: "100 Vessel, 110+ feet in length",
                cReturn: "100 Vessel, NON-Florida Resident or NON-U.S. Citizen, Recreational Use Only or Commercial Exempt, 110+ feet in length|189.75|189.75|189.75|189.75|189.75|189.75|189.75|189.75|189.75|189.75|189.75|189.75|379.50|379.50|379.50|5|189.75|2|2|2|0"
            }, //done
            {
                cName: "101 Vessel Dealer",
                cReturn: "101 Vessel, NON-Florida Resident or NON-U.S. Citizen, Recreational Use, Vessel Dealer|25.50|25.50|25.50|25.50|25.50|25.50|25.50|25.50|25.50|25.50|25.50|25.50|51.00|51.00|51.00|2|2|2|2|2|0"
            }, //done
            {
                cName: "Exempt Vessel,Girl Scout,Boy Scout,Government",
                cReturn: "Vessel, NON-Florida Resident or NON-U.S. Citizen, Recreational Use, Exempt Vessel,Girl Scout,Boy Scout,Government|0.00|0.00|0.00|0.00|0.00|0.00|0.00|0.00|0.00|0.00|0.00|0.00|0.00|0.00|0.00|5|2|2|2|2|0"
            },
            {
                cName: "Antique Vessel, at least 30 years old, Recreational Use only, with certification",
                cReturn: "Antique Vessel, at least 30 years old, NON-Florida Resident or NON-U.S. Citizen, Recreational Use only, with certification|0.00|0.00|0.00|0.00|0.00|0.00|0.00|0.00|0.00|0.00|0.00|0.00|0.00|0.00|0.00|5|0.00|2|2|2|0"
            },
        ]
    },
    //non-Florida Resident or Non-US for COMMERCIAL USE
    {
        cName: "Vessel, NON-Florida Resident or NON-U.S. Citizen, Commercial Use",
        oSubMenu: [ //add $50 commercial fee
            {
                cName: "100 Vessel, 1 to 11 feet in length",
                cReturn: "100 Vessel, NON-Florida Resident or NON-U.S. Citizen, Commercial Use, 1 to 11 feet in length|5.50|5.50|5.50|5.50|5.50|5.50|5.50|5.50|5.50|5.50|5.50|5.50|11.00|11.00|11.00|5|5.50|2|2|2|50"
            }, //done
            {
                cName: "100 Vessel, 12 to 15 feet in length",
                cReturn: "100 Vessel, NON-Florida Resident or NON-U.S. Citizen, Commercial Use, 12 to 15 feet in length|16.25|16.25|16.25|16.25|16.25|16.25|16.25|16.25|16.25|16.25|16.25|16.25|32.50|32.50|32.50|5|16.25|2|2|2|50"
            }, //done
            {
                cName: "100 Vessel, 16 to 25 feet in length",
                cReturn: "100 Vessel, NON-Florida Resident or NON-U.S. Citizen, Commercial Use, 16 to 25 feet in length|28.75|28.75|28.75|28.75|28.75|28.75|28.75|28.75|28.75|28.75|28.75|28.75|57.50|57.50|57.50|5|28.75|2|2|2|50"
            }, //done
            {
                cName: "100 Vessel, 26 to 39 feet in length",
                cReturn: "100 Vessel, NON-Florida Resident or NON-U.S. Citizen, Commercial Use, 26 to 39 feet in length|78.25|78.25|78.25|78.25|78.25|78.25|78.25|78.25|78.25|78.25|78.25|78.25|156.50|156.50|156.50|5|78.25|2|2|2|50"
            }, //done
            {
                cName: "100 Vessel, 40 to 64 feet in length",
                cReturn: "100 Vessel, NON-Florida Resident or NON-U.S. Citizen, Commercial Use, 40 to 64 feet in length|127.75|127.75|127.75|127.75|127.75|127.75|127.75|127.75|127.75|127.75|127.75|127.75|255.50|255.50|255.50|5|127.75|2|2|2|50"
            }, //done
            {
                cName: "100 Vessel, 65 to 109 feet in length",
                cReturn: "100 Vessel, NON-Florida Resident or NON-U.S. Citizen, Commercial Use, 65 to 109 feet in length|152.75|152.75|152.75|152.75|152.75|152.75|152.75|152.75|152.75|152.75|152.75|152.75|305.50|305.50|305.50|5|152.75|2|2|2|50"
            }, //done
            {
                cName: "100 Vessel, 110+ feet in length",
                cReturn: "100 Vessel, NON-Florida Resident or NON-U.S. Citizen, Commercial Use, 110+ feet in length|189.75|189.75|189.75|189.75|189.75|189.75|189.75|189.75|189.75|189.75|189.75|189.75|379.50|379.50|379.50|5|189.75|2|2|2|50"
            }, //done
            {
                cName: "101 Vessel Dealer",
                cReturn: "101 Vessel, NON-Florida Resident or NON-U.S. Citizen, Commercial Use, Vessel Dealer|25.50|25.50|25.50|25.50|25.50|25.50|25.50|25.50|25.50|25.50|25.50|25.50|51.00|51.00|51.00|2|2|2|2|2|50"
            }, //done
            {
                cName: "Exempt Vessel,Girl Scout,Boy Scout,Government,",

                cReturn: "Vessel, NON-Florida Resident or NON-U.S. Citizen, Commercial Use, Exempt Vessel,Girl Scout,Boy Scout,Government,|0.00|0.00|0.00|0.00|0.00|0.00|0.00|0.00|0.00|0.00|0.00|0.00|0.00|0.00|0.00|5|2|2|2|2|50"
            }
        ]
    }];

module.exports = vessels;



// WEBPACK FOOTER //
// ./src/modules/data/vessels.js